import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {Button, Divider, Typography} from "@material-ui/core";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import { useSubmitCancelFormStyles } from './Styles/SubmitCancelFormStyle';

type SettingsModalProps = {
    title: string | React.ReactElement;
    subTitle?: string | React.ReactElement;
    isOpen: boolean;
    isSaveDisabled?: boolean;
    close: () => void;
    cancel?: () => void;
    save: () => void;
    isTNext?: boolean; // Певерести как сохранить или продолжить
    children: React.ReactNode;
    onSubmit?: any;
    noFooter?: boolean|undefined;
};

export const SubmitCancelForm = observer((props: SettingsModalProps) => {
    const {title, subTitle, isOpen, isSaveDisabled, isTNext,
        close, save, cancel, children, onSubmit} = props;
    const classes = useSubmitCancelFormStyles();
    const {t} = useTranslation();
    const translate = (variable: string) => {
        return t('core.submitcancelform.' + variable);
    };

    return (
        <div>
            <Modal
                className={classes.modal}
                open={isOpen}
                onClose={close}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500, }}
            >
                <Fade in={isOpen}>
                    <form onSubmit={onSubmit}>
                        <div className={classes.paper}>
                            <div className={classes.title}>
                                <Typography variant={"h4"}>
                                    {title}
                                </Typography>
                                <Typography variant={"h6"}>
                                    {subTitle ?? ''}
                                </Typography>
                            </div>
                            <div className={classes.body}>
                                {children}
                            </div>
                            { (props.noFooter === undefined||props.noFooter===false) &&
                                <div className={classes.footer}>
                                    <Divider/>
                                    <div className={classes.footerButtons}>
                                        <Button
                                            variant="contained"
                                            onClick={close}
                                            className={classes.closeButton}
                                        >
                                            {translate('close')}
                                        </Button>
                                        {
                                            cancel && <Button
                                                variant="contained"
                                                onClick={cancel}
                                                className={classes.cancelButton}
                                            >
                                                {translate('cancel')}
                                            </Button>
                                        }
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            className={classes.addButton}
                                            disabled={isSaveDisabled}
                                            onClick={event => {
                                                if (save) {
                                                    event.preventDefault();
                                                    save();
                                                }
                                            }}
                                        >
                                            {isTNext ? translate('next') : translate('submit')}
                                        </Button>
                                    </div>
                                </div>
                            }
                        </div>
                    </form>
                </Fade>
            </Modal>
        </div>
    );
});